/**
 * Login page with LoginForm component
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginForm } from '@/components/auth/LoginForm';
import { ForgotPasswordForm } from '@/components/auth/ForgotPasswordForm';

export function LoginPage() {
  const navigate = useNavigate();
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const handleRegisterClick = () => {
    navigate('/register');
  };

  const handleForgotPasswordClick = () => {
    setShowForgotPassword(true);
  };

  const handleBackToLogin = () => {
    setShowForgotPassword(false);
  };

  return (
    <div className="flex min-h-dvh items-center justify-center bg-gradient-to-br from-purple-50 to-blue-50 p-4 dark:from-gray-900 dark:to-gray-800">
      <main className="w-full max-w-md">
        {showForgotPassword ? (
          <ForgotPasswordForm onBackToLoginClick={handleBackToLogin} />
        ) : (
          <LoginForm
            onRegisterClick={handleRegisterClick}
            onForgotPasswordClick={handleForgotPasswordClick}
          />
        )}
      </main>
    </div>
  );
}
